export default "__VITE_ASSET__DC$OVimY__"